if (!customElements.get('sit-scroll-cue')) {
  customElements.define('sit-scroll-cue', class extends HTMLElement {
    constructor() {
      super();
      this.update = this.update.bind(this);
      this.scrollNext = this.scrollNext.bind(this);
      this.queueUpdate = this.queueUpdate.bind(this);
    }

    connectedCallback() {
      this.hero = this.closest('.sit-page')?.querySelector('.sit-hero');
      this.button = this.querySelector('button');
      this.bundles = document.getElementById(this.button?.getAttribute('aria-controls'));
      if (!this.hero || !this.button || !this.bundles) return;
      this.button.addEventListener('click', this.scrollNext);
      window.addEventListener('scroll', this.queueUpdate, { passive: true });
      window.addEventListener('resize', this.queueUpdate, { passive: true });
      window.visualViewport?.addEventListener('resize', this.queueUpdate, { passive: true });
      this.update();
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.scrollNext);
      window.removeEventListener('scroll', this.queueUpdate);
      window.removeEventListener('resize', this.queueUpdate);
      window.visualViewport?.removeEventListener('resize', this.queueUpdate);
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }

    queueUpdate() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.update();
      });
    }

    update() {
      const height = window.visualViewport?.height || window.innerHeight;
      const hero = this.hero.getBoundingClientRect();
      // The cue is useful only before the bundles enter the viewport.
      this.hidden = !window.matchMedia('(max-width: 749px)').matches ||
        hero.top >= height || hero.bottom <= 0 ||
        this.bundles.getBoundingClientRect().top < height * 0.85;
    }

    scrollNext() {
      window.scrollBy({
        top: window.visualViewport?.height || window.innerHeight,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }
  });
}
